module.exports = __webpack_public_path__ + "assets/align-justify-active.229e4621.svg";